module.exports = __webpack_public_path__ + "images/alert-icon.svg";